// queryClient.js
import { QueryClient } from '@tanstack/react-query';

const isTestEnvironment = process.env.NODE_ENV === 'test';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: isTestEnvironment ? 0 : 1000 * 60 * 5, // 5 minutes
      gcTime: isTestEnvironment ? 0 : 1000 * 60 * 30, // 30 minutes
      retry: isTestEnvironment ? false : 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
